module.exports = __webpack_public_path__ + "static/media/arrow_right.74b48936.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Shared/arrow_right.svg
// module id = 316
// module chunks = 2